export const convertToOtp = (value: boolean) => {
    return value ? 'true' : 'false';
};
